import React from 'react';
import { BaseResourceListProps, SimpleList, SvgBin, SvgEdit } from '@app/components';
import { roleApi } from '@app/store';
import { IRole, PERMISSION_WILDCARD } from '@tickeat/permissions';
import { theme } from '@app/theme';
import { createColumnHelper } from '@tanstack/react-table';
import { useTable } from '@app/hooks/useTable';
import { CheckPermissions } from '@app/components/CheckPermissions';

const columnHelper = createColumnHelper<IRole>();

export const RoleList = ({
  onUpdate,
  onDelete,
  onRowPress,
  selectedRowItem,
}: BaseResourceListProps<IRole>) => {
  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <SimpleList.HeaderItem width="75%">
          <SimpleList.HeaderItemLabel>Nom</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: (info) => {
        return (
          <SimpleList.ItemCol width="75%">
            <SimpleList.ItemImageWrapper>
              <SimpleList.ItemText align="left" bold numberOfLines={2} active={info.active}>
                {info.getValue()}
              </SimpleList.ItemText>
            </SimpleList.ItemImageWrapper>
          </SimpleList.ItemCol>
        );
      },
    }),
    columnHelper.display({
      id: 'actions',
      header: () => (
        <SimpleList.HeaderItem width="25%" align="center">
          <SimpleList.HeaderItemLabel>Actions</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: ({ row, active }) => (
        <SimpleList.ItemCol width="25%">
          {!row.original.permissions.includes(PERMISSION_WILDCARD) && (
            <SimpleList.ItemActions>
              <CheckPermissions permissions={['dashboard::roles.update']}>
                <SimpleList.ItemAction onPress={() => onUpdate(row.original)}>
                  <SvgEdit color={active ? '#FFF' : theme.colors.celadonblue} />
                </SimpleList.ItemAction>
              </CheckPermissions>

              <CheckPermissions permissions={['dashboard::roles.delete']}>
                <SimpleList.ItemAction onPress={() => onDelete(row.original)}>
                  <SvgBin color={active ? '#FFF' : theme.colors.celadonblue} />
                </SimpleList.ItemAction>
              </CheckPermissions>
            </SimpleList.ItemActions>
          )}
        </SimpleList.ItemCol>
      ),
    }),
  ];

  const { table, setSearch, isFetching } = useTable({
    columns,
    useQuery: ({ pagination, search }) =>
      roleApi.useReadManyRolesQuery({
        pagination,
        filters: {
          name: {
            $contains: search,
          },
        },
        sort: [],
      }),
  });

  return (
    <SimpleList
      table={table}
      isFetching={isFetching}
      onSearch={setSearch}
      selectedRowItem={selectedRowItem}
      onRowPress={onRowPress}
    />
  );
};
